import { localizedNoteType } from "../../intl/shared-resources/notetype.js";
import { ChipVariant } from "../../components/chip/types.js";
import { NoteType } from "../../contract/pam.js";
const getNoteTypeChipsMapping = (chipType) => ({
  [NoteType.Global]: {
    label: localizedNoteType[NoteType.Global],
    chipType,
    chipVariant: ChipVariant.DropdownDefault
  },
  [NoteType.Request]: {
    label: localizedNoteType[NoteType.Request],
    chipType,
    chipVariant: ChipVariant.DropdownDefault
  }
});
export {
  getNoteTypeChipsMapping
};
//# sourceMappingURL=noteTypeChipsConfig.js.map
